module.exports = __webpack_public_path__ + "img/smart.072735f9.png";